export default function () {
  let prevFlipped = null;

  document.querySelectorAll(".specs-item__flip").forEach((flip_btn) => {
    flip_btn.addEventListener("click", () => {
      const flipped = flip_btn.closest(".specs-item__inner");
      if (prevFlipped) prevFlipped.classList.remove("is-flipped");
      flipped.classList.add("is-flipped");
      prevFlipped = flipped;
    });
  });

  document.querySelectorAll(".specs-item__back").forEach((card_back) => {
    card_back.addEventListener("click", () => {
      card_back.closest(".specs-item__inner").classList.remove("is-flipped");
    });
  });
}
